// Module 8 — Operations Advanced (OPS-01 to OPS-17)
import React, { useState, useEffect, useCallback } from 'react';
import AppShell from '../../components/layout/AppShell';
import api from '../../services/api';
import { fmtPKR, fmtDate, fmtDT, addrStr } from '../../utils/helpers';
import { Spinner, EmptyState, Modal } from '../../components/common';
import { shipmentApi } from '../../services/api';
import toast from 'react-hot-toast';
import { Truck, CheckCircle, AlertCircle } from 'lucide-react';

// â”€â”€ OPS-04/05 Pickup Assignment â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export function PickupAssignmentPage() {
  const [pending, setPending] = useState([]);
  const [riders, setRiders]   = useState([]);
  const [loading, setLoad]    = useState(true);
  const [selected, setSelected] = useState([]);
  const [showAssign, setShowAssign] = useState(false);
  const [riderId, setRiderId]  = useState('');

  const load = useCallback(async () => {
    setLoad(true);
    Promise.all([
      api.get('/shipments?status=BOOKING_CONFIRMED&limit=100').then(r=>r.data).catch(()=>({ success:false, data:{shipments:[]} })),
      api.get('/employees?role=RIDER&limit=50').then(r=>r.data).catch(()=>({ success:false, data:[] })),
    ]).then(([s, e]) => {
      setPending(s.success?s.data?.shipments||[]:[]); setRiders(e.success?e.data||[]:[]);
    }).finally(()=>setLoad(false));
  },[]);
  useEffect(()=>{ load(); },[load]);

  const toggle = (id) => setSelected(prev => prev.includes(id) ? prev.filter(x=>x!==id) : [...prev, id]);

  const assign = async () => {
    if (!riderId) { toast.error('Select a rider'); return; }
    if (!selected.length) { toast.error('Select at least one shipment'); return; }
    try {
      await Promise.all(selected.map(tid =>
        api.patch('/shipments/'+tid+'/status', { status:'PICKUP_SCHEDULED', notes:'Assigned to rider', riderId }).then(r=>r.data)
      ));
      toast.success(selected.length+' shipments assigned'); setSelected([]); setShowAssign(false); load();
    } catch(e) { toast.error('Assignment failed'); }
  };

  return (
    <AppShell title="Pickup Assignment" actions={
      selected.length > 0 && <button className="btn btn-primary btn-sm" onClick={()=>setShowAssign(true)}><Truck size={13}/> Assign {selected.length} to Rider</button>
    }>
      {selected.length > 0 && (
        <div className="alert alert-info" style={{ marginBottom:12, display:'flex', justifyContent:'space-between' }}>
          <span>{selected.length} shipment(s) selected</span>
          <button onClick={()=>setSelected([])} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--info)' }}>Clear</button>
        </div>
      )}
      <div className="card">
        <div className="table-wrap">
          {loading ? <Spinner /> : pending.length ? (
            <table>
              <thead><tr><th><input type="checkbox" onChange={e=>setSelected(e.target.checked?pending.map(s=>s.tracking_id):[])}/></th><th>Tracking ID</th><th>Service</th><th>Pickup Address</th><th>Weight</th><th>Billing</th><th>COD</th></tr></thead>
              <tbody>
                {pending.map(s=>(
                  <tr key={s.tracking_id} style={{ background:selected.includes(s.tracking_id)?'#EFF6FF':undefined }}>
                    <td><input type="checkbox" checked={selected.includes(s.tracking_id)} onChange={()=>toggle(s.tracking_id)}/></td>
                    <td><code style={{ fontSize:'.78rem', fontWeight:700, color:'var(--navy)' }}>{s.tracking_id}</code></td>
                    <td className="text-sm">{s.service_type}</td>
                    <td className="text-sm">{addrStr(s.pickup_address)}</td>
                    <td className="text-sm">{s.weight_actual}kg</td>
                    <td><span className="badge badge-info" style={{ fontSize:'.65rem' }}>{s.billing_model}</span></td>
                    <td>{s.cod_amount>0?fmtPKR(s.cod_amount):'—'}</td>
                    <td>
                      <button className="btn btn-danger btn-sm" style={{ fontSize:'.7rem' }}
                        onClick={async()=>{ if(!window.confirm('Cancel booking '+s.tracking_id+'?')) return; try{ await api.patch('/shipments/'+s.tracking_id+'/status',{ status:'CANCELLED', notes:'Cancelled from pickup screen' }); toast.success('Cancelled'); load(); }catch(e){ toast.error(e.response?.data?.message||'Failed'); } }}>
                        Cancel
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : <EmptyState icon="📦" title="No pending pickups" />}
        </div>
      </div>
      <Modal open={showAssign} onClose={()=>setShowAssign(false)} title="Assign to Rider">
        <div className="modal-body">
          <div className="form-group">
            <label className="form-label">Select Rider</label>
            <select className="form-control" value={riderId} onChange={e=>setRiderId(e.target.value)}>
              <option value="">— Choose rider —</option>
              {riders.map(r=><option key={r.emp_id} value={r.emp_id}>{r.name} ({r.emp_code})</option>)}
            </select>
          </div>
          <div style={{ padding:'10px 14px', background:'var(--gray-50)', borderRadius:8, fontSize:'.82rem' }}>
            Assigning <strong>{selected.length}</strong> shipments to the selected rider as PICKUP_SCHEDULED.
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-outline" onClick={()=>setShowAssign(false)}>Cancel</button>
          <button className="btn btn-primary" onClick={assign}><Truck size={13}/> Assign</button>
        </div>
      </Modal>
    </AppShell>
  );
}

// â”€â”€ OPS-06/07 Delivery Sheet & POD â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export function DeliverySheetPage() {
  const [shipments, setShipments] = useState([]);
  const [loading, setLoad]        = useState(true);
  const [selected, setSelected]   = useState(null);
  const [podForm, setPodForm]     = useState({ notes:'', podType:'SIGNATURE' });

  useEffect(()=>{
    api.get('/shipments?status=OUT_FOR_DELIVERY&limit=100').then(r=>r.data)
      .then(r=>{ if(r.success) setShipments(r.data?.shipments||[]); })
      .finally(()=>setLoad(false));
  },[]);

  const markDelivered = async (trackingId) => {
    try {
      await api.patch('/shipments/'+trackingId+'/status', { status:'DELIVERED', notes:'Delivered — '+podForm.podType, ...podForm }).then(r=>r.data);
      toast.success('Marked as DELIVERED'); setSelected(null);
      setShipments(prev => prev.filter(s=>s.tracking_id!==trackingId));
    } catch(e) { toast.error(e.response?.data?.message||'Failed'); }
  };

  const markAttempted = async (trackingId, reason) => {
    try {
      await api.patch('/shipments/'+trackingId+'/status', { status:'DELIVERY_ATTEMPTED', notes:reason||'Customer not available' }).then(r=>r.data);
      toast.success('Marked as ATTEMPTED');
      setShipments(prev => prev.filter(s=>s.tracking_id!==trackingId));
    } catch(e) { toast.error('Failed'); }
  };

  const printSheet = () => {
    const w = window.open('','_blank');
    w.document.write('<html><head><title>Delivery Sheet</title><style>body{font-family:Arial;font-size:11px}table{width:100%;border-collapse:collapse}th,td{border:1px solid #ddd;padding:6px}th{background:#1B2A4A;color:white}@media print{body{margin:8px}}</style></head><body>'+
      '<h2 style="color:#1B2A4A">ECL — Delivery Sheet — '+new Date().toLocaleDateString('en-PK')+'</h2>'+
      '<table><thead><tr><th>#</th><th>Tracking ID</th><th>Customer</th><th>Address</th><th>Phone</th><th>COD</th><th>Status</th><th>Signature</th></tr></thead><tbody>'+
      shipments.map((s,i)=>'<tr><td>'+(i+1)+'</td><td style="font-family:monospace;font-weight:bold">'+s.tracking_id+'</td>'+
        '<td>'+(typeof s.delivery_address==='object'?s.delivery_address.contactName||'':s.delivery_address||'')+'</td>'+
        '<td>'+(typeof s.delivery_address==='object'?s.delivery_address.line1+', '+s.delivery_address.city:'')+'</td>'+
        '<td>'+(typeof s.delivery_address==='object'?s.delivery_address.contactPhone||'—':'—')+'</td>'+
        '<td style="font-weight:bold">'+(s.cod_amount>0?'PKR '+Number(s.cod_amount).toLocaleString():'—')+'</td>'+
        '<td>OUT FOR DELIVERY</td><td style="min-width:80px"></td></tr>'
      ).join('')+
      '</tbody></table><script>window.onload=function(){window.print()}</script></body></html>');
  };

  return (
    <AppShell title="Delivery Sheet" actions={
      <button className="btn btn-outline btn-sm" onClick={printSheet}>🖨️ Print Sheet</button>
    }>
      <div style={{ marginBottom:12, fontSize:'.82rem', color:'var(--gray-500)' }}>
        {shipments.length} shipments out for delivery
      </div>
      <div className="card">
        <div className="table-wrap">
          {loading ? <Spinner /> : shipments.length ? (
            <table>
              <thead><tr><th>#</th><th>Tracking ID</th><th>Deliver To</th><th>Address</th><th>COD</th><th>Actions</th></tr></thead>
              <tbody>
                {shipments.map((s,i)=>(
                  <tr key={s.tracking_id}>
                    <td style={{ fontWeight:600 }}>{i+1}</td>
                    <td><code style={{ fontSize:'.78rem', fontWeight:700, color:'var(--navy)' }}>{s.tracking_id}</code></td>
                    <td>
                      <div style={{ fontWeight:500, fontSize:'.85rem' }}>{typeof s.delivery_address==='object'?s.delivery_address.contactName||'—':s.delivery_address||'—'}</div>
                      <div style={{ fontSize:'.72rem', color:'var(--gray-400)' }}>{typeof s.delivery_address==='object'?s.delivery_address.contactPhone||'':'—'}</div>
                    </td>
                    <td className="text-sm">{addrStr(s.delivery_address)}</td>
                    <td style={{ fontWeight:s.cod_amount>0?700:400, color:s.cod_amount>0?'var(--amber)':undefined }}>
                      {s.cod_amount>0?fmtPKR(s.cod_amount):'—'}
                    </td>
                    <td>
                      <div style={{ display:'flex', gap:4 }}>
                        <button className="btn btn-success btn-sm" style={{ fontSize:'.68rem' }} onClick={()=>setSelected(s)}>
                          <CheckCircle size={11}/> Delivered
                        </button>
                        <button className="btn btn-warning btn-sm" style={{ fontSize:'.68rem' }} onClick={()=>markAttempted(s.tracking_id,'Customer not available')}>
                          <AlertCircle size={11}/> Attempted
                        </button>
                        <button className="btn btn-outline btn-sm" style={{ fontSize:'.68rem' }}
                            onClick={async()=>{ if(!window.confirm('Cancel shipment '+s.tracking_id+'?')) return; try{ await api.patch('/shipments/'+s.tracking_id+'/status',{ status:'CANCELLED', notes:'Cancelled from delivery sheet' }); toast.success('Cancelled'); setShipments(prev=>prev.filter(x=>x.tracking_id!==s.tracking_id)); }catch(e){ toast.error('Failed'); } }}>
                            Cancel
                          </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : <EmptyState icon="✅" title="No shipments out for delivery" />}
        </div>
      </div>
      <Modal open={!!selected} onClose={()=>setSelected(null)} title={'Mark Delivered — '+(selected?.tracking_id||'')}>
        <div className="modal-body">
          {selected?.cod_amount>0 && (
            <div style={{ padding:'12px 16px', background:'#FFFBEB', borderRadius:8, marginBottom:14, border:'1px solid #FDE68A', fontWeight:600 }}>
              💵 Collect COD: {fmtPKR(selected.cod_amount)}
            </div>
          )}
          <div className="form-group">
            <label className="form-label">POD Type</label>
            <select className="form-control" value={podForm.podType} onChange={e=>setPodForm(f=>({...f,podType:e.target.value}))}>
              {['SIGNATURE','PHOTO','OTP','IN_PERSON'].map(t=><option key={t} value={t}>{t.replace(/_/g,' ')}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Delivery Notes</label>
            <input className="form-control" placeholder="e.g. Left with receptionist" value={podForm.notes} onChange={e=>setPodForm(f=>({...f,notes:e.target.value}))}/>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-outline" onClick={()=>setSelected(null)}>Cancel</button>
          <button className="btn btn-success" onClick={()=>markDelivered(selected?.tracking_id)}><CheckCircle size={13}/> Confirm Delivered</button>
        </div>
      </Modal>
    </AppShell>
  );
}

// â”€â”€ OPS-13/14 Exception Handling â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export function ExceptionHandlingPage() {
  const [exceptions, setExceptions] = useState([]);
  const [loading, setLoad]          = useState(true);
  const [selected, setSelected]     = useState(null);
  const [actionForm, setActionForm] = useState({ action:'', notes:'', newStatus:'' });

  useEffect(()=>{
    api.get('/shipments?status=DELIVERY_ATTEMPTED&limit=100').then(r=>r.data)
      .then(r=>{ if(r.success) setExceptions(r.data?.shipments||[]); }).finally(()=>setLoad(false));
  },[]);

  const applyAction = async () => {
    if (!actionForm.newStatus) { toast.error('Select an action'); return; }
    try {
      await api.patch('/shipments/'+selected.tracking_id+'/status', {
        status: actionForm.newStatus, notes: actionForm.notes||actionForm.action
      }).then(r=>r.data);
      toast.success('Status updated'); setSelected(null);
      setExceptions(prev=>prev.filter(s=>s.tracking_id!==selected.tracking_id));
    } catch(e) { toast.error('Failed'); }
  };

  return (
    <AppShell title="Exception Handling">
      <div style={{ marginBottom:12, fontSize:'.82rem', color:'var(--gray-500)' }}>{exceptions.length} unresolved exceptions</div>
      <div className="card">
        <div className="table-wrap">
          {loading ? <Spinner /> : exceptions.length ? (
            <table>
              <thead><tr><th>Tracking ID</th><th>Attempts</th><th>Deliver To</th><th>COD</th><th>Booked</th><th>Action</th></tr></thead>
              <tbody>
                {exceptions.map(s=>(
                  <tr key={s.tracking_id}>
                    <td><code style={{ fontSize:'.78rem', fontWeight:700, color:'var(--navy)' }}>{s.tracking_id}</code></td>
                    <td style={{ textAlign:'center' }}><span className={`badge ${s.attempts>=3?'badge-danger':'badge-warning'}`}>{s.attempts||0}</span></td>
                    <td className="text-sm">{addrStr(s.delivery_address)}</td>
                    <td>{s.cod_amount>0?fmtPKR(s.cod_amount):'—'}</td>
                    <td className="text-sm">{fmtDate(s.booked_at)}</td>
                    <td>
                      <button className="btn btn-outline btn-sm" style={{ fontSize:'.7rem' }} onClick={()=>setSelected(s)}>
                        Take Action
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : <EmptyState icon="✅" title="No unresolved exceptions" />}
        </div>
      </div>
      <Modal open={!!selected} onClose={()=>setSelected(null)} title={'Exception — '+(selected?.tracking_id||'')}>
        <div className="modal-body">
          <div className="form-group">
            <label className="form-label">Action</label>
            <select className="form-control" value={actionForm.newStatus} onChange={e=>setActionForm(f=>({...f,newStatus:e.target.value}))}>
              <option value="">— Select action —</option>
              <option value="OUT_FOR_DELIVERY">Re-attempt Delivery</option>
              <option value="RTO_INITIATED">Initiate RTO</option>
              <option value="DELIVERED">Mark Delivered (exception)</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Reason / Notes <span className="req">*</span></label>
            <textarea className="form-control" rows={3} placeholder="Explain the reason for this action"
              value={actionForm.notes} onChange={e=>setActionForm(f=>({...f,notes:e.target.value}))}/>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-outline" onClick={()=>setSelected(null)}>Cancel</button>
          <button className="btn btn-primary" onClick={applyAction}>Apply Action</button>
        </div>
      </Modal>
    </AppShell>
  );
}

// â”€â”€ OPS-15/16/17 Rider Cash Settlement â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export function RiderCashSettlementPage() {
  const [settlements, setSettlements] = useState([]);
  const [loading, setLoad]            = useState(true);
  const [selected, setSelected]       = useState(null);
  const [depositForm, setDepositForm] = useState({ bankSlipRef:'', amount:'', hubId:'' });

  useEffect(()=>{
    api.get('/finance/cod?depositStatus=PENDING&limit=100').then(r=>r.data)
      .then(r=>{ if(r.success) setSettlements(r.data||[]); }).finally(()=>setLoad(false));
  },[]);

  const settle = async () => {
    if (!depositForm.bankSlipRef) { toast.error('Bank slip reference required'); return; }
    try {
      await api.patch('/cod/'+selected.cod_id+'/deposit', { bankSlipUrl:depositForm.bankSlipRef }).then(r=>r.data);
      // Create CPV voucher for cash settlement
      await api.post('/finance/vouchers', {
        voucherType:'CRV', amount:parseFloat(selected.amount_collected||0),
        description:'COD deposit — '+selected.tracking_id,
        referenceNo:depositForm.bankSlipRef, partyType:'employee', partyName:selected.rider_name,
        voucherDate:new Date().toISOString().slice(0,10),
        lines:[
          { accountCode:'1020', debit:parseFloat(selected.amount_collected||0), credit:0, description:'Bank deposit COD' },
          { accountCode:'1030', debit:0, credit:parseFloat(selected.amount_collected||0), description:'COD cash cleared' },
        ],
      }).catch(()=>{});
      toast.success('Settlement recorded and GL entry created');
      setSelected(null); setSettlements(prev=>prev.filter(s=>s.cod_id!==selected.cod_id));
    } catch(e) { toast.error('Failed'); }
  };

  const grouped = settlements.reduce((m,s)=>{
    const k = s.rider_id||'unknown';
    if (!m[k]) m[k] = { rider_name:s.rider_name||'Unknown', items:[], total:0 };
    m[k].items.push(s); m[k].total += parseFloat(s.amount_collected||0);
    return m;
  },{});

  return (
    <AppShell title="Rider Cash Settlement (OPS-15/16)">
      <div style={{ marginBottom:12, display:'flex', gap:16, fontSize:'.85rem' }}>
        <span>Pending: <strong>{settlements.length}</strong> transactions</span>
        <span>Total: <strong style={{ color:'var(--amber)' }}>{fmtPKR(settlements.reduce((s,x)=>s+parseFloat(x.amount_collected||0),0))}</strong></span>
      </div>
      {Object.entries(grouped).map(([rid, g])=>(
        <div key={rid} className="card" style={{ marginBottom:12 }}>
          <div className="card-header">
            <span className="card-title">🛵 {g.rider_name}</span>
            <span style={{ fontWeight:700, color:'var(--amber)' }}>{fmtPKR(g.total)}</span>
          </div>
          <div className="table-wrap">
            <table>
              <thead><tr><th>Tracking ID</th><th>Collected</th><th>Collection Time</th><th>Action</th></tr></thead>
              <tbody>
                {g.items.map(item=>(
                  <tr key={item.cod_id}>
                    <td><code style={{ fontSize:'.78rem' }}>{item.tracking_id}</code></td>
                    <td style={{ fontWeight:600, color:'var(--amber)' }}>{fmtPKR(item.amount_collected)}</td>
                    <td className="text-sm">{item.collection_at?fmtDT(item.collection_at):'—'}</td>
                    <td>
                      <button className="btn btn-success btn-sm" style={{ fontSize:'.7rem' }} onClick={()=>setSelected(item)}>
                        Deposit
                      </button>
                      <button className="btn btn-danger btn-sm" style={{ fontSize:'.7rem' }}
                        onClick={async()=>{ if(!window.confirm('Mark as shortfall?')) return; try{ await api.patch('/finance/cod/'+item.cod_id+'/shortfall',{}); toast.success('Marked as shortfall'); setSettlements(prev=>prev.filter(s=>s.cod_id!==item.cod_id)); }catch(e){ toast.error(e.response?.data?.message||'Failed'); } }}>
                        Shortfall
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
      {!loading && Object.keys(grouped).length === 0 && <EmptyState icon="💰" title="All COD settled" />}
      <Modal open={!!selected} onClose={()=>setSelected(null)} title="Record Bank Deposit">
        <div className="modal-body">
          <div style={{ padding:'10px 14px', background:'#FFFBEB', borderRadius:8, marginBottom:14 }}>
            <div style={{ fontWeight:600 }}>Amount to deposit: {fmtPKR(selected?.amount_collected)}</div>
            <div style={{ fontSize:'.78rem', color:'var(--gray-500)' }}>Tracking: {selected?.tracking_id}</div>
          </div>
          <div className="form-group"><label className="form-label">Bank Slip / Reference <span className="req">*</span></label><input className="form-control" placeholder="Bank deposit slip number" value={depositForm.bankSlipRef} onChange={e=>setDepositForm(f=>({...f,bankSlipRef:e.target.value}))}/></div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-outline" onClick={()=>setSelected(null)}>Cancel</button>
          <button className="btn btn-success" onClick={settle}>Confirm Deposit + GL Entry</button>
        </div>
      </Modal>
    </AppShell>
  );
}
